import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import localStorageService from "../../../utils/helpers/services/localStorageService";
import {IDENTITY_SERVICES_PRODUCTS} from '../../../utils/helpers/constants/localStorageKeys';

import './CardOffer.css';


const CardOffer = ({ props, couponValidation=false }) => {
    const [dolars, setDolars] = useState('');
    const [cents, setCents] = useState('');
    const history = useHistory();

    const [currentPath, setCurrentPath] = useState('');

    useEffect(() => {
        setCurrentPath(window.location.pathname);
        if( couponValidation ){
            const discount = (  (parseFloat(props.subscriptionPrice) * 30) /100).toFixed(2);
            props.subscriptionPrice = (parseFloat(props.subscriptionPrice) - discount.toString()).toFixed(2).toString();
        }
            setDolars(props.subscriptionPrice);
            setCents(props.subscriptionPrice);
    }, [couponValidation]);


    const  handleGoToCheckout = ( subscriptionType ) =>{
        console.log("los props que gaurdar");
        console.log(props)
            localStorageService.saveProduct( IDENTITY_SERVICES_PRODUCTS.CARD_PRODUCT_SUBSCRIPTON, props);
            sessionStorage.setItem('sectionName','price');
            window.open('/checkout', '_self');
        }

    const cardHeigth = currentPath === '/checkout' ? '25em' : 'auto';
    return (


        <div className="CardOffer__container" style={{height : cardHeigth}}>
            <div className="CardOffer__card-container">
                <div className="CardOffer__card-title" >
                    <h1 >{props.subscriptionType}</h1>
                </div>
                {
                    (currentPath !== '/checkout' || currentPath === '/checkout' ) && <div className="CardOffer__card-trial-info" >
                        <p>{props.subscriptionTrialInfo} <b>${props.subscriptionTrialPrice}</b></p>
                    </div>
                } 

                <div className="CardOffer__card-price">
                    <p>
                    <span style={{fontWeight : '500'}}>Then</span> <span className="CardOffer__dolar-price">{`$${dolars.split('.')[0]}`}</span><span className="CardOffer__cents-price">{`.${cents.split('.')[1]}`}</span>
                    </p>
                </div>

                <div className="CardOffer__card-description" >
                    <p>
                        {props.subscriptionDescription}
                    </p>
                </div>
                {(currentPath !== '/checkout') && <div className="CardOffer__button-container">
                    <div className="CardOffer__button">
                    
                        <button onClick={(e) => { e.preventDefault(); handleGoToCheckout( props.subscriptionType); }}>
                            BUY
                        </button>
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default CardOffer;